import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
export const Image = /*#__PURE__*/_styled("img", process.env.NODE_ENV === "production" ? {
  target: "ehhhwz90"
} : {
  target: "ehhhwz90",
  label: "Image"
})(process.env.NODE_ENV === "production" ? {
  name: "h1pquf",
  styles: "width:160px;height:160px;object-fit:cover"
} : {
  name: "h1pquf",
  styles: "width:160px;height:160px;object-fit:cover/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkltYWdlLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUNnQyIsImZpbGUiOiJJbWFnZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmV4cG9ydCBjb25zdCBJbWFnZSA9IHN0eWxlZC5pbWcgYFxuICB3aWR0aDogMTYwcHg7XG4gIGhlaWdodDogMTYwcHg7XG4gIG9iamVjdC1maXQ6IGNvdmVyO1xuYDtcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPUltYWdlLmpzLm1hcCJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});